import {FormPageLayout} from "@flexinet/ui-components";
import {useRegistrars} from "../../registrars";
import {Title} from "@mantine/core";
import {NavLink} from 'react-router-dom';
import {useTopLevelDomains} from "../../top-level-domains";
import {useEffect} from "react";
import {UploadForm} from "../forms/UploadForm";

export const UploadPage = () => {
    const {
        items: registrars,
        fetchRecords: fetchRegistrars
    } = useRegistrars()
    const {
        items: tlds,
        fetchRecords: fetchTopLevelDomains,
    } = useTopLevelDomains()

    useEffect(() => {
        fetchRegistrars()
        fetchTopLevelDomains()
    }, [])

    return (
        <FormPageLayout
            title="Domain Bulk Import"
            pageNavigation={<></>}
        >
            {!registrars || !tlds || registrars.length === 0 || tlds.length === 0 ?
                <Title order={3}>Please, <NavLink to={'/registrars/add'}>add at least one registrar</NavLink> before
                    importing domain names.</Title> :
                <UploadForm />}

        </FormPageLayout>
    );
};